import React from 'react'
import { AchCurrency } from './achCurrency'

export const AchCurrencyAPI = () => {
  return (
    <AchCurrency />
  )
}
